import { Injectable } from '@angular/core';
import { UserCompetencyAwardProcessNotificationMetadata } from '@app/competencies/models/user-competency-award-process-notification-metadata';
import { CompetencyStatusEventsService } from '@app/competencies/services/competency-status-events.service';
import { GeneralNotificationViewModel } from '@app/notification/models/general-notification-view-model';
import { UserNotificationType } from '@app/notification/models/user-notification-type';
import { NotificationSignalRService } from '@app/notification/services/notification-signalR.service';
import { NotificationTranslationService } from '@app/notification/services/notification-translation.service';
import { ToastService } from '@app/shared/services/toast.service';
import { filter, throttleTime } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompetencyStatusService {

	private initialized = false;

	constructor (
		private readonly notificationService: NotificationSignalRService,
		private readonly toastService: ToastService,
		private readonly notificationTranslationService: NotificationTranslationService,
		private readonly competencyStatusEventsService: CompetencyStatusEventsService
	) { }

	init (): void {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
		let failedNotificationThrottleTimeSeconds = 15;
		this.notificationService
			.onUserNotificationReceived
			.pipe(
				filter(notification => notification.type === UserNotificationType.UserCompetencyAwardProcessFailed),
				throttleTime(failedNotificationThrottleTimeSeconds * 1000)
			)
			.subscribe({
				next: notification => this.onUserCompetencyAwardProcessFailedNotificationReceived(notification)
			});
		this.notificationService
			.onUserNotificationReceived
			.pipe(
				filter(notification => notification.type === UserNotificationType.UserCompetencyAwardProcessCompleted)
			)
			.subscribe({
				next: notification => this.onUserCompetencyAwardProcessCompletedNotificationReceived(notification)
			});
	}

	private onUserCompetencyAwardProcessCompletedNotificationReceived (notification: GeneralNotificationViewModel): void {
		this.notificationTranslationService.translateNotificationObject(notification);
		this.parseMetadataJsonAndRefreshData(notification.metadata);
		this.toastService.notify(notification.message);
	}

	private onUserCompetencyAwardProcessFailedNotificationReceived (notification: GeneralNotificationViewModel): void {
		this.notificationTranslationService.translateNotificationObject(notification);
		this.parseMetadataJsonAndRefreshData(notification.metadata);
		this.toastService.warn(notification.message);
	}

	private parseMetadataJsonAndRefreshData (metadataString: string): void {
		let metadata: UserCompetencyAwardProcessNotificationMetadata;
		try {
			metadata = JSON.parse(metadataString);
		} catch (e) {
			console.error(e);
		}
		this.competencyStatusEventsService.notifyRefresh(metadata.userCompetencyStatusSummaryId);
	}
}
